// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qeVtCi4YzE0QyMlHlE9N{padding-left:6px;padding-right:6px}.BD41WDlLo5g3Ap2TwcqY{align-items:center;gap:6px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": `qeVtCi4YzE0QyMlHlE9N`,
	"mergeFieldAction": `BD41WDlLo5g3Ap2TwcqY`
};
export default ___CSS_LOADER_EXPORT___;
